import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, PERMISSIONS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'permission',
  url: `${PERMISSIONS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
